import { ICategoryFormButton } from '../../CategoryNew/types';

export const parseCategoryButton = (buttons?: Array<string>): Array<ICategoryFormButton> | undefined => {
    if (!buttons?.length) return;

    return buttons.map((item, idx) => {
        const itemArray = item.split('::');

        return {
            id: idx,
            link: itemArray[1],
            name: itemArray[0],
            img: {
                alt: itemArray[3],
                src: itemArray[2],
                title: itemArray[4],
            },
        };
    });
};
